import React from 'react';
import styles from './ResizeHandle.module.css';

export interface ResizeHandleProps {
  onMouseDown: (e: React.MouseEvent) => void;
  isResizing: boolean;
  disabled?: boolean;
}

/**
 * ResizeHandle Component
 * Provides a draggable handle for resizing panels horizontally
 */
export const ResizeHandle: React.FC<ResizeHandleProps> = ({
  onMouseDown,
  isResizing,
  disabled = false,
}) => {
  return (
    <div
      className={`${styles.resizeHandle} ${isResizing ? styles.resizing : ''} ${disabled ? styles.disabled : ''}`}
      onMouseDown={disabled ? undefined : onMouseDown}
      role="separator"
      aria-orientation="vertical"
      aria-label="Resize panel"
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      onKeyDown={(e) => {
        if (disabled) return;
        // Optional: Add keyboard support for resize
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault();
          // Could implement keyboard-based resize here
        }
      }}
    >
      <div className={styles.handleBar} />
    </div>
  );
};
